import React, { useEffect, useState, useMemo } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../Middleware/Firebase/firebase";
import {Bar, BarChart, LineChart,Tooltip,ResponsiveContainer,CartesianGrid,XAxis,YAxis,Line} from 'recharts'


export default function SupplierDashboard() {

  const [pedidos, setPedidos] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [fornecedores, setFornecedores] = useState([]);

  // 🔥 Tempo real
  useEffect(() => {

    const unsub1 = onSnapshot(collection(db, "orders"), snap => {
      setPedidos(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    const unsub2 = onSnapshot(collection(db, "users"), snap => {
      setUsuarios(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    const unsub3 = onSnapshot(collection(db, "supplier"), snap => {
      setFornecedores(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    return () => {
      unsub1();
      unsub2();
      unsub3();
    };

  }, []);

  // 🔥 Agrupar por mês
  const relatorioMensal = useMemo(() => {

    const meses = {};
   //--------------------------------------------------------
    pedidos.forEach(p => {
     
      if (!p.createdAt) return;

      const data = p.createdAt.toDate
        ? p.createdAt.toDate()
        : new Date(p.createdAt);

      const mes = data.toLocaleString("default", { month: "short" });

      if (!meses[mes]) {
        meses[mes] = {
          mes,
          totalPedidos: 0,
          receita: 0
        };
      }

      meses[mes].totalPedidos += 1;
      meses[mes].receita += Number(p.total || 0);

   
    });
    //-------------------------------


    //----------------------------------

    return Object.values(meses);

  }, [pedidos]);

  // 🔥 Estatísticas gerais
  const receitaTotal = pedidos.reduce((acc, p) => acc + Number(p.total || 0), 0);

  return (
    <div className="p-6">

      <h1 className="text-2xl font-bold mb-6">
        Dashboard Avançado
      </h1>

      {/* 🔢 Cards Resumo */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">

        <div className="bg-white p-4 rounded shadow">
          <p>Total Pedidos</p>
          <h2 className="text-xl font-bold">{pedidos.length}</h2>
        </div>

        <div className="bg-white p-4 rounded shadow">
          <p>Receita Total</p>
          <h2 className="text-xl font-bold">{receitaTotal} Kz</h2>
        </div>

        <div className="bg-white p-4 rounded shadow">
          <p>Usuários</p>
          <h2 className="text-xl font-bold">{usuarios.length}</h2>
        </div>

        <div className="bg-white p-4 rounded shadow">
          <p>Fornecedores</p>
          <h2 className="text-xl font-bold">{fornecedores.length}</h2>
        </div>

      </div>

      {/* 📊 Gráfico Receita Mensal */}
      <div className="bg-white p-6 rounded shadow mb-8">
        <h2 className="text-lg font-semibold mb-4">
          Receita Mensal
        </h2>

        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={relatorioMensal}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="mes" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="receita" fill="#6366F1" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* 📈 Pedidos por Mês */}
      <div className="bg-white p-6 rounded shadow">
        <h2 className="text-lg font-semibold mb-4">
          Pedidos por Mês
        </h2>

        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={relatorioMensal}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="mes" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="totalPedidos" stroke="#10B981" />
          </LineChart>
        </ResponsiveContainer>
      </div>

    </div>
  );
}
